import React from "react";
import { FlaskConical, Radio, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/** Live/Test segmented toggle for the topbar. Non-admins see a locked
 * "Test / Demo" pill only — the switch is simply absent for them, there is
 * nothing to click. */
export function EnvSwitch() {
  const { env, canAccessLive, switchEnv, isCustomer, toggleEnabled } = useAuth();
  if (isCustomer || !toggleEnabled) return null;

  if (!canAccessLive) {
    return (
      <span className="env-pill env-pill-locked" title="Only admin can access Live data" data-testid="env-pill-locked">
        <Lock size={11} /> Test / Demo
      </span>
    );
  }

  return (
    <div className="env-switch" data-testid="env-switch" role="group" aria-label="Live or Test environment">
      <button
        className={`env-seg ${env === "live" ? "active-live" : ""}`}
        onClick={() => switchEnv("live")}
        data-testid="env-switch-live"
        title="Real production data">
        <Radio size={11} /> Live
      </button>
      <button
        className={`env-seg ${env === "test" ? "active-test" : ""}`}
        onClick={() => switchEnv("test")}
        data-testid="env-switch-test"
        title="Sandboxed demo clone — safe to play around">
        <FlaskConical size={11} /> Test
      </button>
    </div>
  );
}

/** Full-width banner shown under the topbar whenever the current session is
 * in Test/Demo mode, so nobody mistakes cloned demo data for the real
 * thing. */
export function EnvBanner() {
  const { env, isCustomer } = useAuth();
  if (isCustomer || env !== "test") return null;
  return (
    <div className="env-banner" data-testid="env-banner">
      <FlaskConical size={13} />
      <span>You're in the <strong>Test / Demo</strong> environment — a sandboxed copy of the data. Nothing you do here affects real customers, jobs or emails.</span>
    </div>
  );
}
